import { Injectable } from '@angular/core';
import { IBookingWithType } from './IBookingWithType';

export const VehicleRentalType: string = 'VehicleRental';

@Injectable()
export class VehicleRentalBookingService {

    public isVehicleRentalBooking(booking: IBookingWithType): boolean {
        return booking && booking.type && booking.type.indexOf(VehicleRentalType) > -1;
    }

    public hasServices(bookingExtraData: any): boolean {
        return Boolean(bookingExtraData?.booking?.serviceArray?.length);
    }
}